import React, { Dispatch, SetStateAction } from 'react';
import { Star } from './Star';

import './StarArray.css';
import axios from 'axios';
import { getApiToken } from '../../utils/cob-utils';
export interface IReviewData {
    average: number;
    total: number;
    overall: number;
    size?: number;
    productId?: string;
}

export const StarArray = (data: IReviewData): JSX.Element => {  
    const percentage: number = Math.round((data.average / data.overall) * 100);

    return (
        <div className='star-container' role='img' aria-label={`Review Stars with rating of ${0.05 * percentage} out of 5`}>
            <div className='star-array' aria-hidden='true'>
                {[...Array(data.overall)].map((_count: number, index: number) => (
                    <Star key={index} color='#ccc' size={data.size ?? 18} />
                ))}
            </div>
            <div className='star-array' aria-hidden='true' style={{ clipPath: `polygon(0 0, ${percentage}% 0, ${percentage}% 100%, 0 100%)` }}>
                {[...Array(data.overall)].map((_count: number, index: number) => (
                    <Star key={index} color='#ffc302' size={data.size ?? 18} />
                ))}
            </div>
        </div>
    );

};

const getBazaarvoiceApiToken = () => {
    const token = getApiToken('bazaarvoiceKey');
    return token;
};

export const getBazaarVoiceStarData = async (bvProductId: string): Promise<IReviewData> => {
    const bazaarvoiceKey = getBazaarvoiceApiToken();

    if (!bazaarvoiceKey) {
        return Promise.reject();
    }

    return new Promise<IReviewData>((resolve, reject) => {
        axios.get(`//api.bazaarvoice.com/data/statistics.json?apiversion=5.4&passkey=${bazaarvoiceKey}&filter=productid:${bvProductId}&stats=Reviews`)
            .then((result) => {
                if (result.data.Results.length <= 0) {
                    return reject('Empty result for Bazaar Voice Star Data Lookup');
                }

                const data: IReviewData = {
                    average: result.data.Results[0]
                        .ProductStatistics
                        .ReviewStatistics
                        .AverageOverallRating,

                    total: result.data.Results[0]
                        .ProductStatistics
                        .ReviewStatistics
                        .TotalReviewCount,

                    overall: result.data.Results[0]
                        .ProductStatistics
                        .ReviewStatistics
                        .OverallRatingRange,

                    size: 18,
                };

                return resolve(data);
            })
            .catch((err) => reject(err));
    });
};

export const bazaarvoiceSetStarData = (bvProductId: string, setState: Dispatch<SetStateAction<IReviewData>>): void => {
    const bazaarvoiceKey = getBazaarvoiceApiToken();

    if (!bazaarvoiceKey) {
        return;
    }

    axios.get(`//api.bazaarvoice.com/data/statistics.json?apiversion=5.4&passkey=${bazaarvoiceKey}&filter=productid:${bvProductId}&stats=Reviews`).then((result) => {
        if (result.data.Results.length > 0) {
            setState({
                average: result.data.Results[0]
                    .ProductStatistics
                    .ReviewStatistics
                    .AverageOverallRating,

                total: result.data.Results[0]
                    .ProductStatistics
                    .ReviewStatistics
                    .TotalReviewCount,

                overall: result.data.Results[0]
                    .ProductStatistics
                    .ReviewStatistics
                    .OverallRatingRange,

                size: 18,
            });
        }
    }).catch((err) => console.error(`Failed to pull card review data: ${err}`));

};

export const fetchBatchBVData = async (bvProductIds: string[]): Promise<IReviewData[]> => {
    const bazaarvoiceKey = getBazaarvoiceApiToken();

    if (!bazaarvoiceKey) {
        return Promise.reject();
    }

    const response = await fetch(`//api.bazaarvoice.com/data/statistics.json?apiversion=5.4&passkey=${bazaarvoiceKey}&filter=productid:${bvProductIds.join(',')}&stats=Reviews`);
    const result = await response.json();
    return result.Results.map((item: any): IReviewData => ({
        productId: item.ProductStatistics.ProductId,
        average: item.ProductStatistics.ReviewStatistics.AverageOverallRating,
        total: item.ProductStatistics.ReviewStatistics.TotalReviewCount,
        overall: item.ProductStatistics.ReviewStatistics.OverallRatingRange,
    }));
};
